export * from './get-global.util';
export * from './is-promise.util';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/class-transformer/esm5/utils/index.js
// module id = 804
// module chunks = 3